import type { ColumnDef } from "@tanstack/react-table";
import { buildTagColumn } from "@/components/Table";
import { renderEmptyCellState } from "@/components/Table/utils";
import { formatEnumLabel } from "../../_utils";
import type { CommissionPartnerNode } from "../types";

export function getColumns(): ColumnDef<CommissionPartnerNode, unknown>[] {
  return [
    {
      accessorKey: "name",
      header: "Partner",
      size: 280,
      meta: { sortType: "text" }
    },
    {
      accessorKey: "legacyId",
      header: "Legacy ID",
      size: 140,
      enableSorting: false,
      cell: ({ getValue }) => renderEmptyCellState(getValue())
    },
    buildTagColumn<CommissionPartnerNode>({
      accessorKey: "status",
      header: "Status",
      size: 120,
      getTagLabel: (row) => formatEnumLabel(row.status),
      getTagType: (row) => (row.status === "ACTIVE" ? "success" : "surface"),
      getTagStyle: () => "strong"
    })
  ];
}
